module.exports = __webpack_public_path__ + "static/media/SuisseIntl-SemiBold-WebS.6c72b66f.ttf";